export enum UserManagementActivationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
